import { Heading } from 'almanac-ui/Heading/Heading'
import Styles from './Explanation.module.scss'
import { Text } from 'almanac-ui/Text/Text'
import { Care, PaymentConfirmation, ReviewShare } from 'almanac-ui/icons/blaze/32'
import cx from 'classnames'
import { ReactComponent as Connector } from './connector.svg'
import dayjs from 'dayjs'
import { Button } from 'components/Button'
import { ArrowRight } from 'almanac-ui/icons/16'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { GhostButton } from 'components/Buttons/GhostButton'
import { ReactComponent as LeftArrowIcon } from 'assets/icons/arrowLeft24.svg'
import ProgressBar from 'screens/LoginOrSignup/components/ProgressBar/ProgressBar'
import Shared from 'screens/LoginOrSignup/Shared.module.scss'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { usePaymentPlans } from 'hooks/queries/usePaymentPlans'
import ImageAssembly from '../../../Testimonials/CartoonTestimonials/ImageAssembly'

interface Props {
  totalSteps?: number
  transitionPage: (page: string) => void
}

export const Explanation = ({ totalSteps, transitionPage }: Props) => {
  const { isTabletPortrait } = useResponsiveDesign()
  const reminderDate = dayjs(new Date()).add(5, 'days').format('ddd, MMM D, YYYY')
  const subscriptionDate = dayjs(new Date()).add(7, 'days').format('ddd, MMM D, YYYY')
  const paymentPlans = usePaymentPlans()?.data?.payment_plans
  const creatorPlan = paymentPlans?.find((plan) => plan.key === PaymentPlanKey.BlazePro)
  const creatorPlanPrice = creatorPlan?.price.month.unit_amount
  const { isMobile } = useResponsiveDesign()

  return (
    <div data-testid="explanation" className={Styles.container}>
      {isTabletPortrait && (
        <>
          <div className={cx(Styles.header, Shared.header)}>
            <GhostButton className={Shared.backButton} aria-label="Back" onClick={() => transitionPage('GO_BACK_PLAN')}>
              <LeftArrowIcon />
            </GhostButton>
            {totalSteps && <ProgressBar totalSteps={totalSteps} currentStep={6} />}
          </div>
          <p className={cx(Shared.title, Shared.isBlaze, Styles.title)}>How your free trial works</p>
        </>
      )}
      <div className={Styles.content}>
        <div className={Styles.steps}>
          <div className={Styles.step}>
            <div className={Styles.connector}>
              <Connector />
            </div>
            <div className={cx(Styles.icon, Styles.filled, Styles.stepOneIcon)}>
              <Care />
            </div>
            <div className={Styles.text}>
              <Heading level={4}>
                <span className={Styles.heading}>Today</span>
              </Heading>
              <Text variant="p2">
                <div>Start your free Blaze Pro trial and see how it can give you super powers.</div>
              </Text>
            </div>
          </div>

          <div className={Styles.step}>
            <div className={cx(Styles.icon, Styles.stepTwoIcon)}>
              <ReviewShare />
            </div>
            <div className={Styles.text}>
              <Heading level={4}>
                <span className={Styles.heading}>{reminderDate}</span>
              </Heading>
              <Text variant="p2">
                <div>We will send you a reminder 2 days before your Blaze trial ends.</div>
              </Text>
            </div>
          </div>

          <div className={Styles.step}>
            <div className={cx(Styles.icon, Styles.stepThreeIcon)}>
              <PaymentConfirmation />
            </div>
            <div className={Styles.text}>
              <Heading level={4}>
                <span className={Styles.heading}>{subscriptionDate}</span>
              </Heading>
              <Text variant="p2">
                <div>
                  Your subscription starts at ${creatorPlanPrice} USD/month unless you cancel during the trial period.
                </div>
              </Text>
            </div>
          </div>
        </div>
        <div className={Styles.bottomContent}>
          {isTabletPortrait && (
            <>
              <Button
                variant="blazePrimary"
                className={Styles.submitButton}
                type="submit"
                size="xl"
                endIcon={ArrowRight}
                onPress={() => transitionPage('NEXT')}
              >
                Next
              </Button>
              <span className={Styles.smallPrint}>Cancel anytime, we’ll remind you before trial ends.</span>
            </>
          )}
        </div>
        {!isTabletPortrait && !isMobile && <ImageAssembly offsetTop={0} page={'blazeStartFreeTrial'} />}
      </div>
    </div>
  )
}
